import { useState } from "react";
import { Field } from "@/components/kit";
import { Stepper } from "@/components/Stepper";
import { WATER_KEY, waterLimit } from "@/lib/safety";

// Carrier's high-water limit for the "call dispatch" warning (inches, default 1).
export function WaterLimit({ t }) {
  const [v, setV] = useState(waterLimit);
  const save = (x) => { const n = Math.max(0.125, x || 1); setV(n); try { localStorage.setItem(WATER_KEY, String(n)); } catch { /* full */ } };
  return (
    <div className="card" data-testid="water-limit-card">
      <Field label={t("High-water limit (call dispatch)")}>
        <Stepper testID="water-limit" unit="in" decimal step={0.25} max={12} value={v} onValue={save} />
      </Field>
      <div className="card-sub">{t("Water at or above this on a console scan shows a red call-dispatch warning. Default 1 in.")}</div>
    </div>
  );
}
